import React from 'react';
import { useParams } from 'react-router';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { UserClubRole } from '@swf/core/types/Poker';
import { useCheckUserClubRole } from '@swf/poker';

import type { Props } from '../Container';

import CloseOrLeaveClub from './CloseOrLeaveClub/CloseOrLeaveClub';
import ClubSeason from './ClubSeason/ClubSeason';
import DeleteClub from './DeleteClub/DeleteClub';
import EmailNotifications from './EmailNotifications/EmailNotifications';
import styles from './Settings.scss';

const Settings: React.FC<Props> = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const isManager = useCheckUserClubRole(clubId, [UserClubRole.Manager]);
  const canLeave = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Member]);
  const showClubSeason = useFeature(FeatureFlag.PKRHomeGamesStandingsIteration1);

  return (
    <section className={styles.container}>
      <EmailNotifications />
      {canLeave && <CloseOrLeaveClub />}
      {isManager && (
        <>
          {showClubSeason && <ClubSeason />}
          <DeleteClub />
        </>
      )}
    </section>
  );
};

export default Settings;
